import { ButtonGroup, FormControlSizes, ToggleButton } from '@talos/kyoko';
import { FundingRateUpdateMode } from './FundingRateBlotter.types';
import { FUNDING_RATE_BLOTTER_UPDATE_MODE_LABELS } from './tokens';

interface FundingRateUpdateModeToggleProps {
  updateMode: FundingRateUpdateMode;
  onUpdateModeChange: (mode: FundingRateUpdateMode) => void;
  /** data-testid on the ButtonGroup wrapper. */
  groupTestId: string;
  /** data-testid prefix for each ToggleButton; suffixed with `-{mode}`. */
  buttonTestIdPrefix: string;
}

/** Hourly/Daily toggle shared by the main toolbar and the Settings view. */
export function FundingRateUpdateModeToggle({
  updateMode,
  onUpdateModeChange,
  groupTestId,
  buttonTestIdPrefix,
}: FundingRateUpdateModeToggleProps) {
  return (
    <ButtonGroup size={FormControlSizes.Small} data-testid={groupTestId}>
      {Object.values(FundingRateUpdateMode).map(mode => (
        <ToggleButton
          key={mode}
          selected={updateMode === mode}
          onClick={() => onUpdateModeChange(mode)}
          data-testid={`${buttonTestIdPrefix}-${mode}`}
        >
          {FUNDING_RATE_BLOTTER_UPDATE_MODE_LABELS[mode]}
        </ToggleButton>
      ))}
    </ButtonGroup>
  );
}
